function SSBandInteraction(config){
  this.config = config;
  this._init();
}

SSBandInteraction.prototype._init = function(){
  var that = this;
  var container = this.config.container;
  var linksDisabled = this.config.linksDisabled;
  container.bind('mousedown', function(e){
    if (e.which !== 1){
      return;
    }
    // @todo - needs to be optimized. Reading offset on every mouseclick is bad.
    var offset = $(this).offset();
    that.startX = e.pageX - offset.left;

    // @note band interaction is used only for pres.For event interaction in documents, see document displayer
    container.bind('mouseup',function(e){
      var targetNode;
      var target = e.target;
      var targetTagName = target.tagName.toUpperCase();
      if (linksDisabled){
        targetNode = false; // working around jslint. This line shouldn't be needed
      }else if(
        targetTagName === 'SPAN' &&
        target.parentNode.tagName.toUpperCase() === 'A'
      ){
        // new conversion changes, anchor tags have a child span tag
        targetNode = target.parentNode;
      } else if(targetTagName === 'A' || targetTagName === 'AREA'){
        // old conversion structure, anchor tags had no child span tag
        targetNode = target;
      }
      if (targetNode && targetNode.attributes.href) {
        var hrefValue = parseInt(targetNode.attributes.href.value, 10);
        if (isNaN(hrefValue)) {
          window.open(targetNode.href);
        }
        $.slideshareEventManager.trackOutboundClick(targetNode);
        // else{
        //   Turning off internal links for all users
        //            $.slideshareEventManager.trigger('gotoslide' ,{index: hrefValue});
        //           }
      }
      container.unbind('mouseup');
    });
  });

  $(container).bind('click', function(e){
    e.preventDefault();
  });

  $(this).bind('bandclick', function(e){
    e.preventDefault();
    var x = e.ssData.x;

    // if click on left one sixth, prev
    // if click on right one sixth, next

    var bandSize = that.config.width/3;
    if (x < bandSize){
      // trigger previous slide
      $(that).trigger('bandprevious');
    } else if (x > (bandSize * 2)){
      // trigger next slide
      $(that).trigger('bandnext');
    }
  });


  var leftcontainer = $('.leftpoint');
  leftcontainer.click(function(evt){
     $(that).trigger('bandprevious');
  });
  var rightcontainer = $('.rightpoint');
  rightcontainer.click(function(evt){
     $(that).trigger('bandnext');
  });

};

SSBandInteraction.prototype.activate = function(){
  var that = this;
  $(this).bind('bandprevious', function(){
    $.slideshareEventManager.trigger('previous',{source : 'band'});
  });
  $(this).bind('bandnext', function(){
    $.slideshareEventManager.trigger('next',{source : 'band'});
  });
};

SSBandInteraction.prototype.deactivate = function(){
  $(this).unbind('bandprevious');
  $(this).unbind('bandnext');
};

SSBandInteraction.prototype.destroy = function(){

};

export default SSBandInteraction;